import _asyncToGenerator from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _regeneratorRuntime from "/opt/build/repo/node_modules/@babel/runtime/regenerator";
import "core-js/modules/es.promise.finally.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { useEffect, useState } from "react";
import Client from "shopify-buy";
import StoreContext from "./store-context";

var StoreProvider = function StoreProvider(props) {
  var client = Client.buildClient({
    storefrontAccessToken: process.env.GATSBY_SHOPIFY_ACCESS_TOKEN,
    domain: "".concat(process.env.GATSBY_SHOPIFY_SHOP_NAME, ".myshopify.com"),
    language: 'ja-JP'
  });

  var lockCheckout = function lockCheckout() {
    setStore(function (prevState) {
      return _objectSpread(_objectSpread({}, prevState), {}, {
        checkoutEditable: false
      });
    });
  };

  var releaseCheckout = function releaseCheckout() {
    setStore(function (prevState) {
      return _objectSpread(_objectSpread({}, prevState), {}, {
        checkoutEditable: true
      });
    });
  }; // NOTE: initialValue に key を追加する場合は、 StoreContext の defaultValue にも同様に初期値を追加すること。
  // StoreContextを使うコンポーネントの単体テストで、 defaultValue が使われるため。


  var initialStoreValue = {
    client: client,
    checkout: {
      lineItems: [],
      totalPrice: 0
    },
    checkoutEditable: true
  };

  var _useState = useState(initialStoreValue),
      _useState2 = _slicedToArray(_useState, 2),
      store = _useState2[0],
      setStore = _useState2[1];

  var currentTotalQuantity = function currentTotalQuantity() {
    var reducer = function reducer(accumulator, lineItem) {
      return accumulator + lineItem.quantity;
    };

    return store.checkout.lineItems.reduce(reducer, 0);
  };

  var addVariantToCart = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(variantId, quantity) {
      var lineItemsToAdd;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (variantId) {
                _context.next = 2;
                break;
              }

              throw new Error("商品を選択してください");

            case 2:
              // quantity が null, undefined, 0 の時はエラー
              quantity = parseInt(quantity, 10);

              if (quantity) {
                _context.next = 5;
                break;
              }

              throw new Error("数量は 1 以上で入力してください");

            case 5:
              lockCheckout();
              lineItemsToAdd = [{
                variantId: variantId,
                quantity: quantity
              }];
              _context.next = 9;
              return store.client.checkout.addLineItems(store.checkout.id, lineItemsToAdd).then(function (checkout) {
                setStore(function (prevState) {
                  return _objectSpread(_objectSpread({}, prevState), {}, {
                    checkout: checkout
                  });
                });
              }).finally(function () {
                releaseCheckout();
              });

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function addVariantToCart(_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();

  var updateLineItemQuantity = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(lineItemId, quantity) {
      var lineItemsToUpdate;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (lineItemId) {
                _context2.next = 2;
                break;
              }

              throw new Error("数量を変更する商品を選択してください");

            case 2:
              // quantity が null, undefined, 0 の時はエラー
              quantity = parseInt(quantity, 10);

              if (quantity) {
                _context2.next = 5;
                break;
              }

              throw new Error("数量は 1 以上で入力してください");

            case 5:
              lockCheckout();
              lineItemsToUpdate = [{
                id: lineItemId,
                quantity: quantity
              }];
              _context2.next = 9;
              return store.client.checkout.updateLineItems(store.checkout.id, lineItemsToUpdate).then(function (checkout) {
                setStore(function (prevState) {
                  return _objectSpread(_objectSpread({}, prevState), {}, {
                    checkout: checkout
                  });
                });
              }).finally(function () {
                releaseCheckout();
              });

            case 9:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function updateLineItemQuantity(_x3, _x4) {
      return _ref2.apply(this, arguments);
    };
  }();

  var removeLineItem = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(lineItemId) {
      var lineItemsToDelete;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (lineItemId) {
                _context3.next = 2;
                break;
              }

              throw new Error("削除する商品を選択してください");

            case 2:
              lockCheckout();
              lineItemsToDelete = [lineItemId];
              _context3.next = 6;
              return store.client.checkout.removeLineItems(store.checkout.id, lineItemsToDelete).then(function (checkout) {
                setStore(function (prevState) {
                  return _objectSpread(_objectSpread({}, prevState), {}, {
                    checkout: checkout
                  });
                });
              }).finally(function () {
                releaseCheckout();
              });

            case 6:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function removeLineItem(_x5) {
      return _ref3.apply(this, arguments);
    };
  }();

  var proceedToCheckout = function proceedToCheckout() {
    window.open(store.checkout.webUrl);
  };

  useEffect(function () {
    var initializeCheckout = /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(localStorageKey) {
        var setCheckout, resetCheckout, localStorageValue, checkout;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                setCheckout = function setCheckout(checkout) {
                  localStorage.setItem(localStorageKey, checkout.id);
                  setStore(function (prevState) {
                    return _objectSpread(_objectSpread({}, prevState), {}, {
                      checkout: checkout
                    });
                  });
                };

                resetCheckout = function resetCheckout() {
                  localStorage.removeItem(localStorageKey);
                };

                localStorageValue = localStorage.getItem(localStorageKey);

                if (!(localStorageValue != null)) {
                  _context4.next = 20;
                  break;
                }

                _context4.prev = 4;
                _context4.next = 7;
                return store.client.checkout.fetch(localStorageValue);

              case 7:
                checkout = _context4.sent;

                if (!(checkout.completedAt != null)) {
                  _context4.next = 12;
                  break;
                }

                _context4.next = 11;
                return store.client.checkout.create();

              case 11:
                checkout = _context4.sent;

              case 12:
                setCheckout(checkout);
                _context4.next = 18;
                break;

              case 15:
                _context4.prev = 15;
                _context4.t0 = _context4["catch"](4);
                resetCheckout();

              case 18:
                _context4.next = 22;
                break;

              case 20:
                _context4.next = 22;
                return store.client.checkout.create().then(function (checkout) {
                  setCheckout(checkout);
                }).catch(function (err) {
                  resetCheckout();
                });

              case 22:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, null, [[4, 15]]);
      }));

      return function initializeCheckout(_x6) {
        return _ref4.apply(this, arguments);
      };
    }();

    initializeCheckout(props.localStorageKey);
  }, [store.client.checkout]);
  return /*#__PURE__*/React.createElement(StoreContext.Provider, {
    value: {
      store: store,
      currentTotalQuantity: currentTotalQuantity,
      addVariantToCart: addVariantToCart,
      updateLineItemQuantity: updateLineItemQuantity,
      removeLineItem: removeLineItem,
      proceedToCheckout: proceedToCheckout
    }
  }, props.children);
};

export default StoreProvider;